import React, { useEffect, useState } from 'react'
import { ASSETS_FOLDER } from '../../assets';
import { setInfo } from '../../effects/actions';
import { store } from '../../effects/store';
import { CloseIcon } from '../icons';
import { Container, CloseContainer, ImageContainer, Image, ButtonHide, Description  } from './index.styled'
const collections = require('./../../assets/mock-data/collections.json')

function PopupLayerComponent({ content, open, locale }) {
  const [contentState, setContentState] = useState(null) 
  useEffect(() => {
    let data = collections.find(x => x.collection === content)
    setContentState({ path: data?.layer?.path, slug: data?.layer?.slug, name: data?.name  })
  },[content])
  return (
    <Container className={`popuplayer ${open ? 'open' : 'closed'}`}>
      <CloseContainer onClick={() => store.dispatch(setInfo())}>
        <CloseIcon />
      </CloseContainer>
      <ImageContainer>
        <Image src={`${ASSETS_FOLDER}${contentState?.path}${locale === "ru" ? "en" : locale}/${contentState?.slug}.jpg`} />
      </ImageContainer>
      <ButtonHide>
        <Description>
          {contentState?.name}
        </Description>
      </ButtonHide>
    </Container>
  )
}

export default PopupLayerComponent;
